// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__QTJ_H","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2gJPp","obliqueLine":"membershipbadge_obliqueLine__2EQp3"};